/**
 * Stages run inside Order.$lookup.pipeline (after let: eventOid / eventIdStr from parent Event).
 * Direct ObjectId match first (index-friendly), then legacy string eventId match.
 */
export function buildOrderLookupSubpipeline({
  status,
  showExpireOrders,
  validOrderObjectIds,
}: {
  status?: string;
  showExpireOrders: boolean;
  validOrderObjectIds: string[];
}): object[] {
  const stages: object[] = [
    {
      $match: {
        $or: [
          { $expr: { $eq: ["$eventId", "$$eventOid"] } },
          {
            $expr: {
              $eq: [{ $toString: "$eventId" }, "$$eventIdStr"],
            },
          },
        ],
      },
    },
  ];
  if (status) {
    stages.push({
      $match: { status },
    });
  }
  if (!showExpireOrders) {
    stages.push({
      $match: { status: { $ne: "EXPIRED" } },
    });
  }
  if (validOrderObjectIds.length > 0) {
    stages.push({
      $match: {
        _id: {
          $in: validOrderObjectIds.map((oid) => ({ $oid: oid })),
        },
      },
    });
  }
  return stages;
}
